// App shell — sidebar + topbar + main content area.
// Per spec §10. Pure presentation; routing logic lives in App.tsx.

import type { ReactNode } from 'react';
import type { CustomerSummary } from '../../lib/types';
import type { ViewName } from '../../lib/store';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { MobileTabBar } from './MobileTabBar';
import { DetailPanel } from '../DetailPanel';

interface AppShellProps {
  customer: CustomerSummary;
  view: ViewName;
  onNavigate: (next: ViewName) => void;
  children: ReactNode;
}

const VIEW_LABELS: Record<ViewName, string> = {
  home: 'Home',
  reorder: 'Quick Reorder',
  designs: 'My Designs',
  orders: 'Orders',
  kit: 'Brand Kit',
  team: 'My Team',
  help: 'Help & Tutorials',
};

export function AppShell({ customer, view, onNavigate, children }: AppShellProps) {
  return (
    <div className="shell">
      <Sidebar customer={customer} view={view} onNavigate={onNavigate} />
      <div className="main">
        <TopBar viewLabel={VIEW_LABELS[view]} />
        <main className="view-area" key={view}>
          <div className="view">{children}</div>
        </main>
        <MobileTabBar view={view} onNavigate={onNavigate} />
      </div>
      {/* Side drawer mounts at the shell level so it overlays every view. */}
      <DetailPanel />
    </div>
  );
}
